module.exports = __webpack_public_path__ + "img/Manual-Install.fb38f94.svg";